import { Box, ListItem, ListItemText } from '@mui/material';
import React from 'react';
import { Fighter } from '../../../../../../../corelogic/domain/models/fighter.model';
import { formatDateLong } from '../../../../../../../corelogic/domain/utils/date.utils';
import { HubCircularImage } from '../HubCircularImage/HubCircularImage';

interface RankedFighterListItemProps {
  index: number;
  fighter: Fighter;
  points: number;
  date: Date;
  rankIcon?: React.ReactNode;
  onClick?: () => void;
  fighterImage: string | null;
  isImageLoading: boolean;
}

export const RankedFighterListItem: React.FC<RankedFighterListItemProps> = ({
  index,
  fighter,
  points,
  date,
  rankIcon,
  onClick,
  fighterImage,
  isImageLoading,
}) => {
  return (
    <ListItem
      onClick={onClick}
      sx={{
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          transform: 'translateX(5px)',
        },
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              minWidth: 32,
              maxWidth: 32,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {rankIcon}
          </Box>
          <ListItemText
            primary={`${fighter.firstname} ${fighter.lastname}`}
            secondary={
              <React.Fragment>
                <Box
                  component="span"
                  sx={{ fontWeight: 'bold', color: '#cc0000' }}
                >
                  {points} points
                </Box>
                <Box
                  component="span"
                  sx={{ color: 'rgba(255, 255, 255, 0.5)' }}
                >
                  {' • '}
                  {formatDateLong(date)}
                </Box>
              </React.Fragment>
            }
            sx={{
              textAlign: 'left',
              flex: 1,
              '& .MuiListItemText-primary': {
                fontSize: { xs: '0.9rem', sm: 'clamp(0.6rem, 2.2vw, 0.9rem)' },
                fontWeight: 'normal',
                fontStyle: index < 3 ? 'italic' : 'normal',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              },
              '& .MuiListItemText-secondary': {
                fontSize: { xs: '0.8rem', sm: 'clamp(0.5rem, 2.0vw, 0.8rem)' },
                color: 'rgba(255, 255, 255, 0.7)',
              },
            }}
          />
        </Box>
        <HubCircularImage
          isLoading={isImageLoading}
          imageSrc={fighterImage}
          firstName={fighter.firstname}
          lastName={fighter.lastname}
          size={40}
        />
      </Box>
    </ListItem>
  );
};

export default RankedFighterListItem;
